/* Love Crunch - New Flavors LP prototype interactions */
(function () {
  "use strict";

  /* ---- Buy: tabs switch the whole per-flavor panel ---- */
  var tabs = document.querySelectorAll(".buy-tab");
  var panels = document.querySelectorAll(".buy-panel");
  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      var flavor = tab.dataset.flavor;
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });
      panels.forEach(function (p) { p.hidden = p.dataset.flavor !== flavor; });
    });
  });

  /* ---- Buy: per-panel gallery thumbnails ---- */
  panels.forEach(function (panel) {
    var main = panel.querySelector(".buy__main img");
    var thumbs = panel.querySelectorAll(".buy-thumb");
    thumbs.forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.dataset.img && main) main.src = btn.dataset.img;
        thumbs.forEach(function (t) { t.classList.remove("is-active"); });
        btn.classList.add("is-active");
      });
    });
  });

  /* ---- Buy: quantity steppers (each panel has its own) ---- */
  document.querySelectorAll(".stepper").forEach(function (stepper) {
    var input = stepper.querySelector("input");
    stepper.querySelectorAll("button").forEach(function (b) {
      b.addEventListener("click", function () {
        var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10));
        input.value = v;
      });
    });
  });


  /* ---- Buy: pack picker swaps variant, price and availability ---- */
  document.querySelectorAll(".buy-panel").forEach(function (panel) {
    var packs = panel.querySelectorAll(".buy__packs .buy-plan");
    if (!packs.length) return;
    var idInput = panel.querySelector('input[name="id"]');
    var priceEl = panel.querySelector(".buy__price strong");
    var addBtn = panel.querySelector(".btn-buy");
    packs.forEach(function (pk) {
      pk.addEventListener("click", function () {
        packs.forEach(function (x) { x.classList.remove("is-active"); });
        pk.classList.add("is-active");
        if (idInput && pk.dataset.vid) idInput.value = pk.dataset.vid;
        if (priceEl && pk.dataset.price) priceEl.textContent = pk.dataset.price;
        if (addBtn) {
          var so = pk.dataset.soldout === "1";
          addBtn.disabled = so;
          var span = addBtn.querySelector("span");
          if (span) span.textContent = so ? "Sold Out" : "Add to Cart";
        }
      });
    });
  });


  /* ---- Smooth travel to the buy element so the jump reads as movement ---- */
  function scrollToBuy(e) {
    var buyEl = document.getElementById("buy");
    if (!buyEl) return;
    if (e) e.preventDefault();
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    buyEl.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
  }

  /* ---- Story cards: Buy Now flips to that flavor's tab, then scrolls ---- */
  document.querySelectorAll(".story .story__buy").forEach(function (link) {
    link.addEventListener("click", function (e) {
      var story = link.closest(".story");
      var flavor = story && ["dubai", "blueberry", "strawberry"].find(function (f) {
        return story.classList.contains("story--" + f);
      });
      if (flavor) {
        var tab = document.querySelector('.buy-tab[data-flavor="' + flavor + '"]');
        if (tab) tab.click();
      }
      scrollToBuy(e);
    });
  });

  /* floating CTA rides the same smooth scroll */
  var floatCtaLink = document.getElementById("floatCta");
  if (floatCtaLink) floatCtaLink.addEventListener("click", scrollToBuy);

  /* ---- FAQ: single-open accordion ---- */
  var items = document.querySelectorAll(".faq__item");
  items.forEach(function (d) {
    d.addEventListener("toggle", function () {
      if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; });
    });
  });

  /* ---- Review slider: chevrons cycle the quotes ---- */
  var slides = document.querySelectorAll(".review__slide");
  if (slides.length) {
    var idx = 0;
    function go(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle("is-active", i === idx); });
    }
    var prev = document.querySelector(".review__chev--l");
    var next = document.querySelector(".review__chev--r");
    /* auto-advance every 5s; manual nav restarts the timer */
    var timer = null;
    function startAuto() {
      stopAuto();
      timer = setInterval(function () { go(idx + 1); }, 5000);
    }
    function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
    if (prev) prev.addEventListener("click", function () { go(idx - 1); startAuto(); });
    if (next) next.addEventListener("click", function () { go(idx + 1); startAuto(); });
    /* pause while the visitor is hovering the slider */
    var reviewCard = document.querySelector(".review");
    if (reviewCard) {
      reviewCard.addEventListener("mouseenter", stopAuto);
      reviewCard.addEventListener("mouseleave", startAuto);
    }
    if (slides.length > 1) startAuto();
  }

  /* ---- UGC: play swaps the still for the inline creator video ---- */
  var play = document.querySelector(".ugc__play");
  var ugcVideo = document.querySelector(".ugc__video");
  var ugcStill = document.querySelector(".ugc__still");
  if (play && ugcVideo) {
    play.addEventListener("click", function () {
      if (ugcStill) ugcStill.hidden = true;
      play.hidden = true;
      ugcVideo.hidden = false;
      ugcVideo.play();
    });
    ugcVideo.addEventListener("ended", function () {
      ugcVideo.hidden = true;
      if (ugcStill) ugcStill.hidden = false;
      play.hidden = false;
    });
  }

  /* ---- Floating CTA: show on scroll, hide when the buy element is in view ---- */
  var cta = document.getElementById("floatCta");
  var buy = document.getElementById("buy");
  if (cta && buy) {
    var buyVisible = false;
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        buyVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0.15 }).observe(buy);
    }
    function update() {
      cta.classList.toggle("is-visible", window.scrollY > 350 && !buyVisible);
    }
    window.addEventListener("scroll", update, { passive: true });
    update();
  }
})();
